import { checkTeamSubscriptionActive } from "Utils/commonAPI";
import SequenceUtils from "Utils/SequenceUtils";
import { sequenceStoreData } from "Stores/sequenceData";
import PaywallUtils from "Utils/PaywallUtils";

/**
 * Shared pre-checks before opening "Import from Contacts" (list → sequence),
 * aligned with bulk add / LinkedIn import guards on the sequence list and overview.
 */
const runImportFromContactsListGuards = async ({
  routerProps,
  sequence,
  sequenceId,
  folderIdFromURL,
  remainingContactCount,
  planName,
  inFreePlan,
  noOfContactsEligible
}) => {
  if (!(await checkTeamSubscriptionActive())) {
    return false;
  }
  if (
    !SequenceUtils.checkAndAllowContactUpload(
      routerProps,
      sequence,
      sequenceId
    )
  ) {
    return false;
  }
  if (SequenceUtils.checkEmailSteps(sequence)) {
    if (!SequenceUtils.inboxConnected(sequence)) {
      SequenceUtils.showNoInboxconnectedPopup(
        routerProps,
        SequenceUtils.getSequencePath(sequence, folderIdFromURL)
      );
      return false;
    }
  }
  await sequenceStoreData.getSenderToken(sequenceId);
  if (sequenceStoreData?.missingSenderTokens?.length > 0) {
    SequenceUtils.showMissingSenderTokenPopup(routerProps);
    return false;
  }
  if (remainingContactCount() <= 0) {
    PaywallUtils.upgradeUtilsFunction(
      "contactsAdded",
      false,
      planName,
      inFreePlan,
      { contactCount: noOfContactsEligible }
    );
    return false;
  }
  return true;
};

export default runImportFromContactsListGuards;
